import {
  AddToBasket,
  trackEvent,
} from '@JohnLewisPartnership/jl-analytics-event-stream';

const convertPrice = (price) => {
  const convertedPrice = {
    now: Number.parseFloat(price.now),
  };

  if (price.was) {
    convertedPrice.was = Number.parseFloat(price.was);
  }

  return convertedPrice;
};

const convertPromotionClassifications = (promoClassifications) => {
  return promoClassifications.map((promoClassification) => {
    return {
      group: promoClassification.group,
    };
  });
};

const convertMultiSkuRating = (reviewSummary) => {
  if (reviewSummary && reviewSummary.rating) {
    const rating = {
      AverageRating: reviewSummary.rating,
    };

    const reviewCount = reviewSummary.binCount
      ? reviewSummary.binCount.match(/\d+/g)
      : [];
    if (reviewCount.length > 0) {
      rating.totalNumber = Number.parseInt(reviewCount[0], 10);
    }

    return rating;
  }

  return {};
};

const convertRating = (rating) => {
  return {
    averageRating: rating.averageRating,
    totalNumber: rating.reviews,
  };
};

const submitAddToBasketEvent = (productData, breadcrumbs, basketData) => {
  const page = {
    type: 'Standard PLP',
    breadcrumbs: breadcrumbs.map((breadcrumb) => ({
      clickable: breadcrumb.clickable === 'true' ? 1 : 0,
      value: breadcrumb.displayName,
    })),
  };

  const payload = {
    implementationID: 'standard-plp-ui',
    products: [productData],
    page,
  };

  if (basketData.products.length > 0) {
    payload.basket = {
      products: basketData.products.map((item) => ({
        price: Number.parseFloat(item.itemPrice),
        productId: item.productId,
        quantity: Number.parseInt(item.qty),
      })),
      subTotal: Number.parseFloat(basketData.subTotal),
      quantity: Number.parseInt(basketData.totalNumberOfItems),
      productCount: basketData.products.length,
    };
  }

  trackEvent(AddToBasket, payload);
};

export const trackSingleSkuAddToBasket = (product, breadcrumbs, basketData) => {
  const {
    id,
    title,
    price,
    brand,
    selectedSwatch,
    promoClassifications,
    rating,
  } = product;

  const eventProduct = {
    id: id,
    name: title,
    price: convertPrice(price),
    brand: brand,
    colour: selectedSwatch.color,
    sku: selectedSwatch.skuId,
    promotionClassifications:
      convertPromotionClassifications(promoClassifications),
    reviews: convertRating(rating),
    citrusAdId: product.adId,
  };

  submitAddToBasketEvent(eventProduct, breadcrumbs, basketData);
};

export const trackMultiSkuAddToBasket = (
  addToBasketSuccessData,
  quickViewAnalyticsData,
  breadcrumbs,
  basketData
) => {
  const { product, skuId } = addToBasketSuccessData;
  const { skus = [], promotionClassifications } = product;

  const selectedSku = skus.find((sku) => sku.id === skuId);

  const eventProduct = {
    id: product.id,
    name: product.name,
    price: convertPrice(selectedSku.prices),
    brand: product.brandInformation.name,
    colour: selectedSku.colour,
    sku: selectedSku.id,
    availableProductSkus: selectedSku.stockLevel,
    promotionClassifications: convertPromotionClassifications(
      promotionClassifications
    ),
    reviews: convertMultiSkuRating(product.reviewSummary),
    size: selectedSku.size,
    citrusAdId: quickViewAnalyticsData.product.citrusAdId,
  };

  submitAddToBasketEvent(eventProduct, breadcrumbs, basketData);
};
